"use client";

import { useRequestMeTeacherResourceAccess } from "./access/useRequestMeTeacherResourceAccess";

export const useIsTeacher = () => {
  const {
    query: { data: isTeacher },
  } = useRequestMeTeacherResourceAccess();

  return isTeacher;
};
